import Avatar from 'components/base/Avatar';
import React, { useState } from 'react';
import { Modal, Card, Dropdown, Nav, Button } from 'react-bootstrap';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import AuthService from 'services/auth.service';
import avatar1 from 'assets/img/team/72x72/avatarsysadmin.png';
import avatar2 from 'assets/img/team/72x72/avatarsysadminops.png';
import avatar3 from 'assets/img/team/72x72/avatarsysadminqa.png';
import avatar4 from 'assets/img/team/72x72/avatarmemberqa.png';
import avatar5 from 'assets/img/team/72x72/avatarmemberops.png';
import { secureStorage } from 'services/secure-storage.service';

const ProfileDropdownMenu = ({
  className,
  onClose
}: {
  className?: string;
  onClose?: () => void;
}) => {
  const currentUser = AuthService.getCurrentUser();
  const datelastseen = new Date(currentUser.lastseen);
  const avatar = secureStorage.getItem('avatar');
  const isSamlAzureUser = currentUser.auth_type === 'saml-azure';
  const isSamlManageEngineUser = currentUser.auth_type === 'saml-manageengine';
  const isLocalUser = currentUser.auth_type === 'local';

  const dashboardpath =
    avatar === 'avatar1' ? '/system-management/system-dashboard' : '/';

  const avatarMap: { [key: string]: string } = {
    avatar1,
    avatar2,
    avatar3,
    avatar4,
    avatar5
  };

  const profileImage = avatarMap[avatar ?? ''] || '';

  const [navItems] = useState([
    {
      label: 'Your main Dashboard',
      icon: 'pie-chart',
      href: dashboardpath
    },
    {
      label: 'View your Profile',
      icon: 'user',
      href: '/user-management/user-profile'
    },
    // Condicional para mostrar cambio de contraseña solo para usuarios locales
    ...(isLocalUser
      ? [
          {
            label: 'Change your Password',
            icon: 'key',
            href: '/authentication/reset-password'
          }
        ]
      : [])
  ]);

  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Dropdown.Menu
        align="end"
        className={classNames(
          className,
          'navbar-top-dropdown-menu navbar-dropdown-caret py-0 dropdown-profile shadow border'
        )}
      >
        <Card className="position-relative border-0">
          <Card.Body className="p-0">
            <div className="d-flex flex-column flex-column justify-content-center gap-2 pt-4 pb-2 flex-center">
              <Avatar src={profileImage} size="xl" />
              <h6 className="text-body-emphasis mb-0">
                {currentUser.name} {currentUser.lastname}
              </h6>
              {isSamlAzureUser && (
                <span className="badge bg-primary fs-10">Azure AD Account</span>
              )}
              {isSamlManageEngineUser && (
                <span className="badge bg-primary fs-10">
                  ManageEngine ADS Account
                </span>
              )}
            </div>
            <div className="mb-2 mt-2 bg-body">
              <div className="fs-10 mx-5 pt-2 text-primary-light">
                Your last conection <br />
              </div>
              <div className="fs-9 mx-5 pb-1">
                {datelastseen.toLocaleString()}
              </div>
            </div>
            <div>
              <Nav className="nav flex-column mb-2 pb-1">
                {navItems.map(item => (
                  <Nav.Item key={item.label}>
                    <Link
                      to={item.href}
                      className="nav-link px-5 d-block"
                      onClick={() => onClose?.()}
                    >
                      <FeatherIcon
                        icon={item.icon}
                        size={16}
                        className="me-2 text-body"
                      />
                      <span className="text-body-highlight">{item.label}</span>
                    </Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
          </Card.Body>
          <Card.Footer className="p-0 border-top border-translucent">
            <div className="px-3">
              <br />
              <a
                href="/authentication/sign-out"
                className="btn btn-primary d-flex flex-center w-100"
              >
                <FeatherIcon icon="log-out" className="me-2" size={18} />
                Sign out
              </a>
            </div>
            <div className="text-center p-1">
              <div
                onClick={() => setModalShow(true)}
                className="fs-10 text-body-quaternary p-0 cursor-pointer"
              >
                Privacy policy
              </div>
            </div>
          </Card.Footer>
        </Card>
      </Dropdown.Menu>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-primary"
          >
            Privacy policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-6 pt-3 pb-0">
          <h2>
            Protecting the Privacy and security of your personal information
          </h2>
          <p>
            <br /> Zanna VirtualMind Solutions, S.L. is committed to protecting
            the privacy and security of your personal information. This Privacy
            Policy outlines how we collect, use, and safeguard the information
            you provide when using our WebApp.
          </p>
          <h4>Information We Collect</h4>
          <p>
            We do not collect any personal information from users to our WebApp.
            We do not use cookies, tracking technologies, or any other means to
            collect personally identifiable information.
          </p>
          <h4>Use of Information</h4>
          <p>
            Since we do not collect any personal information, we do not use it
            for any purpose.
          </p>
          <h4>Third-Party Links</h4>
          <p>
            Our WebApp may contain links to third-party websites for
            informational purposes only. We are not responsible for the privacy
            practices or content of these third-party sites. We encourage you to
            review the privacy policies of any third-party websites you visit.
          </p>
          <h4>Data Security</h4>
          <p>
            While we do not collect personal information, we take reasonable
            measures to protect any non-personal information collected through
            our WebApp. However, please note that no method of transmission over
            the Internet or electronic storage is completely secure, and we
            cannot guarantee absolute security.
          </p>
          <h4>Changes to This Privacy Policy</h4>
          <p>
            We reserve the right to update or change our Privacy Policy at any
            time. Any changes will be posted on this page. We encourage you to
            review this Privacy Policy periodically for any changes.
          </p>
          <h4>Contact Us</h4>
          <p>
            If you have any questions or concerns about our Privacy Policy,
            please contact us at dpo@zanna-vm.com.
          </p>
          <p>
            By using our WebApp, you consent to the terms of this Privacy
            Policy.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfileDropdownMenu;
